var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedRequestImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 117,
    viewBox: "0 0 276 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1146 113C29.1146 113 24.467 78.1658 40.7335 67.6095C54.8982 58.4146 66.6806 52.8306 90.6931 52.1268C114.706 51.423 127.87 51.4195 142.202 36.9978C156.534 22.5761 175.911 0.784383 197.58 0.0523349C218.494 -0.654958 231.273 5.32874 243.277 47.5541C255.282 89.7796 242.888 111.592 242.499 111.943C242.23 112.194 29.1146 113 29.1146 113Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10097_41056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 99C155.673 99 170 84.6731 170 67C170 49.3269 155.673 35 138 35C120.327 35 106 49.3269 106 67C106 84.6731 120.327 99 138 99Z",
    fill: "#FF9800",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.998 92.6004C152.137 92.6004 163.598 81.1389 163.598 67.0004C163.598 52.8619 152.137 41.4004 137.998 41.4004C123.86 41.4004 112.398 52.8619 112.398 67.0004C112.398 81.1389 123.86 92.6004 137.998 92.6004Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 47,
    width: 6,
    height: 28,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.539,
    y: 78.9609,
    width: 6.75,
    height: 6.75,
    rx: 3.375,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10097_41056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(106 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedRequestImage);
export default __webpack_public_path__ + "static/media/pausedRequestImage.ad44333c15a7452ab4143d35018daeb2.svg";
export { ForwardRef as ReactComponent };